import styled, { css } from 'styled-components';
import { listWidth } from '../list/styled';
import { Button } from '@bechtel/gds';

export const CrewChangeDetailContainerStyled = styled.div`
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.white};
  position: absolute;
  left: ${listWidth};
  width: calc(100% - ${listWidth});
`;

export const CrewChangeDetailContentLayoutStyled = styled.div`
  display: grid;
  grid-template-rows: 82px 82px auto 72px;
  height: 100vh;
`;

export const CrewChangeDetailHeaderStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.blue[800]};
  grid-row: 1;
`;

export const CrewChangeDetailSubHeaderStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.blue[100]};
  grid-row: 2;
`;

export const CrewChangeDetailContentStyled = styled.div`
  grid-row: 3;
  overflow-y: scroll;
`;

export const CrewChangeDetailFooterStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.blue[800]};
  grid-row: 4;
`;

export const FooterButtonStyled = styled(Button)`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
    padding-right: ${theme.spacings[600]};
    padding-left: ${theme.spacings[600]};
  `}
`;
